<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-full xl:w-1/3 lg:w-1/2 md:w-1/2">
                <vx-card :title="$t('Data')" class="mb-base page-user-view">
                    <table>
                        <tr>
                            <td class="font-semibold">{{ $t("Name") }}</td>
                            <td>{{ user.name }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{ $t("LName") }}</td>
                            <td>{{ user.l_name }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{ $t("Email") }}</td>
                            <td>{{ user.email }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{ $t("Company") }}</td>
                            <td>{{ user.company }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{ $t("Theme") }}</td>
                            <td>{{ themeText }}</td>
                        </tr>
                    </table>

                    <vs-button class="mt-3 mr-6" style="float: left" color="danger" icon-pack="feather" icon="icon-lock"
                               type="border" @click="changePassPrompt = true">{{ $t("ChangePassword") }}
                    </vs-button>
                    <vs-button class="mt-3" style="float: left" color="success" icon-pack="feather" icon="icon-edit"
                               type="border" @click="changeTheme">{{ $t("ChangeTheme") }}
                    </vs-button>
                    <vs-button v-if="!user.totp_enabled" class="mt-3 mr-6" style="float: left" color="warning"
                               icon-pack="feather" icon="icon-hash" type="border" @click="startTOTPEnable">
                        {{ $t("EnableTOTP") }}
                    </vs-button>
                    <div style="clear: left"></div>

                    <vs-popup :title="$t('ChangePassword')" :active.sync="changePassPrompt">
                        <div id="changePassDiv">
                            <p class="mt-6">{{ $t("OldPass") }}</p>
                            <vs-input type="password" v-model="oldPass" style="width: 100%"></vs-input>
                            <p class="mt-6">{{ $t("NewPass") }}</p>
                            <vs-input type="password" v-model="newPass" style="width: 100%"></vs-input>
                            <vs-divider/>
                            <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit"
                                       type="border" class="mt-6; mr-1" @click="changePass">{{ $t("ChangePassword") }}
                            </vs-button>
                        </div>
                    </vs-popup>

                    <vs-popup :title="$t('EnableTOTP')" :active.sync="enableTOTPPrompt">
                        <div id="enableTOTPDiv">

                            <div class="flex justify-center">
                                <img v-if="totpQRData.length > 0" :src="totpQRData"/>
                            </div>

                            <p class="mt-6">{{ $t("AuthenticatorCode") }}</p>
                            <vs-input type="number" v-model="totpCode" style="width: 100%"></vs-input>
                            <vs-divider/>
                            <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit"
                                       type="border" class="mt-6; mr-1" @click="confirmTOTP">{{ $t("EnableTOTP") }}
                            </vs-button>
                        </div>
                    </vs-popup>
                </vx-card>
            </div>
            <div v-if="report" class="vx-col w-full xl:w-2/3 lg:w-1/2 md:w-1/2 mb-3">
                <vx-card class="mb-base page-user-view">
                    <h3>{{ $t("Statistics") }}:</h3>
                    <div class="vx-row">
                        <div class="mt-6 vx-col w-full xl:w-4/12">
                            <table>
                                <tr v-if="report.available_vacation_days_previous > 0">
                                    <td class="font-semibold">{{ $t("Vacations") }}
                                        ({{ Number(moment().format("YYYY")) - 1 + "/" + moment().format("YYYY") }}):
                                    </td>
                                    <td>
                                        {{ report.available_vacation_days_previous }}/{{
                                            report.available_vacation_days
                                        }}
                                    </td>
                                </tr>
                                <tr v-else>
                                    <td class="font-semibold">{{ $t("Vacations") }}:</td>
                                    <td>{{ report.available_vacation_days }}</td>
                                </tr>
                                <tr>
                                    <td class="font-semibold">{{ $t("SickLeaves") }}:</td>
                                    <td>/</td>
                                </tr>
                            </table>
                        </div>
                        <div class="mt-6 vx-col w-full xl:w-8/12 justify-around">
                            <div class="vx-row justify-around">
                                <vs-button class="mt-2" type="border" color="warning">{{ $t("VacationsContract") }}
                                </vs-button>
                                <vs-button class="mt-2" type="border" color="warning">{{ $t("SickLeaveProofs") }}
                                </vs-button>
                            </div>

                        </div>

                    </div>

                    <vs-divider></vs-divider>
                    <absence-request-adding base-u-r-l="/api/v1/profile"
                                            @updateAbsence="$refs.absencesTable.updateAbsences()"
                                            @updateSickLeaves="$refs.sickLeavesTable.updateSickLeaves()"
                                            @updateParentalLeaves="$refs.parentalLeavesTable.updateParentalLeaves()"
                                            @updateVacations="$refs.vacationsTable.updateVacations()"></absence-request-adding>
                </vx-card>
            </div>
        </div>
        <vs-divider></vs-divider>
        <div class="vx-row" v-if="user.id">
            <div class="vx-col w-full xl:w-1/2 lg:w-1/2  md:w-full p-2">
                <vacations-table ref="vacationsTable" :user-id="user.id"></vacations-table>
            </div>
            <div class="vx-col w-full xl:w-1/2 lg:w-1/2 md:w-full p-2">
                <sick-leave-table ref="sickLeavesTable" :user-id="user.id"></sick-leave-table>
            </div>
            <div class="vx-col w-full xl:w-1/2 lg:w-1/2 md:w-full p-2">
                <absence-table ref="absencesTable" :user-id="user.id"></absence-table>
            </div>
            <div class="vx-col w-full xl:w-1/2 lg:w-1/2 md:w-full p-2">
                <parental-leave-table ref="parentalLeavesTable" :user-id="user.id"></parental-leave-table>
            </div>
        </div>
        <vs-divider></vs-divider>
        <vx-card :title="$t('TimeOverview') + ' - ' + $t(moment(new Date()).format('MMMM'))">
            <div class="vx-row" v-if="this.report">
                <div class="vx-col w-full xl:w-2/3 mb-6">
                    <div slot="no-body">
                        <vue-apex-charts type=radialBar height=345 :options="overviewChartOptions2"
                                         :series="overviewPercentageSeries"/>
                        <div class="flex flex-row justify-around px-8 pb-4 mt-2">
                            <p class="text-center">
                                <span class="block">{{ $t('FinishedHours') }}</span>
                                <span class="text-2xl font-semibold">{{ report.total_time }}</span>
                            </p>
                            <p class="text-center">
                                <span class="block">{{ $t('HoursNeeded') }}</span>
                                <span class="text-2xl font-semibold">{{ report.needed_time.time }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="vx-col w-full xl:w-1/3 xl:order-last  order-first mb-6">
                    <div class="vx-row text-center">
                        <div class="vx-col w-1/2">
                            <div class="lg:ml-6 lg:mt-6 md:mt-0 md:ml-0 sm:ml-6 sm:mt-6">
                                <h1 class="font-bold text-5xl">{{ report.monthly_time_difference }}</h1>
                                <small>{{ $t('MonthlyDifferenceTillNow') }}</small>
                            </div>
                        </div>
                        <div class="vx-col w-1/2">
                            <div class="lg:ml-6 lg:mt-6 md:mt-0 md:ml-0 sm:ml-6 sm:mt-6">
                                <h1 class="font-bold text-5xl">{{ report.total_time_difference }}</h1>
                                <small>{{ $t('TotalDifferenceTillNow') }}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <vs-divider></vs-divider>
            <div class="w-full">
                <vue-apex-charts type=bar height=500 :options="dailyChartOptions" :series="dailyChartData"/>
            </div>
        </vx-card>
        <vx-card class="w-full mt-6">
            <vue-apex-charts type="bar" height="500" :options="this.yearlyChartOptions" :series="yearlyChartData"/>
        </vx-card>

        <own-vehicles-table class="mt-6"/>

      <passkeys-table class="mt-6"/>

    </div>
</template>
<script>

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import VacationsTable from "./VacationsTable";
import SickLeaveTable from "./SickLeaveTable";
import ParentalLeaveTable from "./ParentalLeaveTable";
import AbsenceTable from "./AbsenceTable";
import VueApexCharts from 'vue-apexcharts'
import AbsenceRequestAdding from "./AbsenceRequestAdding";
import OwnVehiclesTable from "./OwnVehiclesTable";
import PasskeysTable from "@/views/UserPage/PasskeysTable.vue";

export default {
    components: {
        AbsenceTable,
        SickLeaveTable,
        ParentalLeaveTable,
        VacationsTable,
        flatPickr,
        AbsenceRequestAdding,
        VueApexCharts,
        OwnVehiclesTable,
      PasskeysTable
    },
    data() {
        return {
            user: {},

            mounted: false,

            oldPass: '',
            newPass: '',
            changePassPrompt: false,

            enableTOTPPrompt: false,
            totpQRData: '',
            totpCode: '',

            categories: [1, 2, 3, 4, 5],

            report: undefined,

            timesChartOptions: {
                labels: [this.$t('Work'), this.$t('Transport'), this.$t('Absence')],
                plotOptions: {
                    radialBar: {
                        size: 165,
                        offsetY: -5,
                        hollow: {
                            size: '25%'
                        },
                        track: {
                            background: "#ebebeb",
                            strokeWidth: '100%',
                            margin: 15,
                        },
                        dataLabels: {
                            show: true,
                            name: {
                                fontSize: '18px',
                            },
                            value: {
                                fontSize: '16px',
                                color: "#636a71",
                                offsetY: 11
                            },
                            total: {
                                show: true,
                                label: this.$t('Total'),
                                formatter: this.getTotal,
                            }
                        }
                    },
                },
                responsive: [{
                    breakpoint: 576,
                    options: {
                        plotOptions: {
                            radialBar: {
                                size: 150,
                                hollow: {
                                    size: '20%'
                                },
                                track: {
                                    background: "#ebebeb",
                                    strokeWidth: '100%',
                                    margin: 15,
                                },
                            }
                        }
                    }
                }],
                colors: ['#7961F9', '#FF9F43', '#EA5455'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        // enabled: true,
                        shade: 'dark',
                        type: 'vertical',
                        shadeIntensity: 0.5,
                        gradientToColors: ['#9c8cfc', '#FFC085', '#f29292'],
                        inverseColors: false,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100]
                    },
                },
                stroke: {
                    lineCap: 'round'
                },
                chart: {
                    height: 355,
                    dropShadow: {
                        enabled: true,
                        blur: 3,
                        left: 1,
                        top: 1,
                        opacity: 0.1
                    },
                }
            },

            overviewChartOptions2: {
                plotOptions: {
                    radialBar: {
                        size: 150,
                        startAngle: -150,
                        endAngle: 150,
                        hollow: {
                            size: '77%',
                        },
                        track: {
                            background: "#bfc5cc",
                            strokeWidth: '50%',
                        },
                        dataLabels: {
                            name: {
                                show: false
                            },
                            value: {
                                offsetY: 18,
                                color: '#99a2ac',
                                fontSize: '4rem'
                            }
                        }
                    }
                },
                colors: ['#00db89'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        type: 'horizontal',
                        shadeIntensity: 0.5,
                        gradientToColors: ['#00b5b5'],
                        inverseColors: true,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100]
                    },
                },
                stroke: {
                    lineCap: 'round'
                },
                chart: {
                    sparkline: {
                        enabled: true,
                    },
                    dropShadow: {
                        enabled: true,
                        blur: 3,
                        left: 1,
                        top: 1,
                        opacity: 0.1
                    },
                },
                labels: [this.$t('Total')],
            },

            dailyChartOptions: {},
            yearlyChartOptions: {},
        }
    },
    methods: {
        updateChartCategories() {

            this.dailyChartOptions = {
                grid: {
                    borderColor: '#ebebeb',
                    padding: {
                        left: 0,
                        right: 0
                    }
                },
                dataLabels: {
                    enabled: false
                },
                chart: {
                    stacked: true,
                    type: 'bar',
                },
                colors: ['#badc58', '#078e40', '#D2691E', '#34495e', '#3498db', '#4834d4', '#e74c3c', '#9b59b6'],
                plotOptions: {
                    bar: {
                        columnWidth: '70%',
                    }
                },
                xaxis: {
                    axisTicks: {
                        show: false,
                    },
                    categories: this.reportDays,
                    axisBorder: {
                        show: false,
                    },
                },
                yaxis: {
                    tickAmount: 5,
                    labels: {
                        style: {
                            cssClass: 'text-grey fill-current',
                        }
                    }
                },
                tooltip: {
                    x: {show: false}
                },
            };

        },
        updateYearlyChart() {
            this.yearlyChartOptions = {
                colors: ['#28C76F', '#7367F0', '#EA5455'],
                plotOptions: {
                    bar: {
                        horizontal: false,
                        endingShape: 'rounded',
                        columnWidth: '55%',
                    },
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },

                xaxis: {
                    categories: this.yearlyChartCategories,
                },
                yaxis: {
                    title: {
                        text: 'h'
                    }
                },
                fill: {
                    opacity: 1

                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + "h"
                        }
                    }
                }
            }
        },
        updateUser() {
            const thisIns = this;
            this.$http.get('/api/v1/profile/')
                .then(function (response) {
                    thisIns.user = response.data;
                })
                .catch(function (error) {
                    thisIns.$vs.notify({
                        title: 'Error',
                        text: error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                });
        },
        changeTheme() {
            const thisIns = this;
            this.$http.get('/api/v1/changeTheme/')
                .then(function () {
                    if (thisIns.$store.state.theme == 'dark') {
                        thisIns.$store.dispatch('updateTheme', "light");
                    } else {
                        thisIns.$store.dispatch('updateTheme', "dark");
                    }
                })
                .catch(function (error) {
                    thisIns.$vs.notify({
                        title: 'Error',
                        text: error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                });
        },
        changePass() {
            const thisIns = this;
            this.$vs.loading({background: this.backgroundLoading, color: 'rgb(255, 255, 255)'})
            this.$http.post('/api/v1/changePass/', {
                password: thisIns.newPass,
                old_pass: thisIns.oldPass,
            }).then(function () {
                thisIns.newPass = "";
                thisIns.oldPass = "";
                thisIns.$vs.loading.close()
                thisIns.changePassPrompt = false;
            }).catch(function (error) {
                thisIns.$vs.loading.close()
                thisIns.changePassPrompt = false;
                thisIns.$vs.notify({
                    title: 'Error',
                    text: error.response.data,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                })
            });
        },
        startTOTPEnable() {
            const thisIns = this;
            this.$vs.loading({background: this.backgroundLoading, color: 'rgb(255, 255, 255)'})
            this.$http.post('/api/v1/profile/enable_totp')
                .then(function (response) {
                    thisIns.totpQRData = response.data.qr_code
                    thisIns.enableTOTPPrompt = true
                }).catch(function (error) {
                thisIns.$vs.notify({
                    title: 'Error',
                    text: error.response.data,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                })
            }).finally(function () {
                thisIns.$vs.loading.close()
            });
        },
        confirmTOTP() {
            const thisIns = this;
            this.$vs.loading({background: this.backgroundLoading, color: 'rgb(255, 255, 255)'})
            this.$http.post('/api/v1/profile/confirm_totp', {totp: this.totpCode})
                .then(function () {
                    thisIns.enableTOTPPrompt = false
                    thisIns.updateUser()
                }).catch(function (error) {
                thisIns.$vs.notify({
                    title: 'Error',
                    text: error.response.data,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                })
            }).finally(function () {
                thisIns.$vs.loading.close()
            });
        },
        getTotal() {
            return this.report.total_time
        }
    },
    computed: {
        themeText: function () {
            if (this.$store.state.theme == 'dark') {
                return this.$t("Dark")
            } else {
                return this.$t("Light")
            }
        },
        overviewPercentageSeries: function () {

            let data = [];

            if (this.report.needed_time) {
                data.push(Number(this.report.done_percentage));
            }
            return data;
        },
        typesPercentageSeries: function () {

            let data = [];

            if (this.report.needed_time) {
                data.push(this.report.time_percentage);
                data.push(this.report.transport_percentage);
                data.push(this.report.absence_percentage);

                return data;
            }

            return [0, 0, 0];
        },
        dailyChartData: function () {

            let data = [];
            let times = [];
            let uninvoiced = [];
            let transport = [];
            let sickLeaves = [];
            let parentalLeaves = [];
            let vacations = [];
            let businessTrips = [];
            let meetings = [];

            if (this.report && this.report.days) {
                for (let key in this.report.days) {
                    if (this.report.days.hasOwnProperty(key)) {
                        uninvoiced.push(this.report.days[key].un_invoiced_time.toFixed(2));
                        times.push(this.report.days[key].total_work_time.toFixed(2));
                        transport.push(this.report.days[key].total_transport_time.toFixed(2));
                        vacations.push(this.report.days[key].vacation_time.toFixed(2));
                        sickLeaves.push(this.report.days[key].sick_leave_time.toFixed(2));
                        parentalLeaves.push(this.report.days[key].parental_leave_time.toFixed(2));
                        businessTrips.push(this.report.days[key].business_trip_time.toFixed(2));
                        meetings.push(this.report.days[key].total_meetings_time.toFixed(2));

                    }
                }
            }

            data.push({name: this.$t("Work"), data: times});
            data.push({name: this.$t("NonInvoicedTime"), data: uninvoiced});
            data.push({name: this.$t("Transport"), data: transport});
            data.push({name: this.$t("SickLeaves"), data: sickLeaves});
            data.push({name: this.$t("ParentalLeaves"), data: parentalLeaves});
            data.push({name: this.$t("Vacations"), data: vacations});
            data.push({name: this.$t("BusinessTrips"), data: businessTrips});
            data.push({name: this.$t("Meetings"), data: meetings});

            return data;

        },
        yearlyChartData: function () {

            let workTimes = [];
            let neededTimes = [];
            let differences = [];

            if (this.report && this.report.last_year_reports) {

                if (this.report.last_year_reports.length < 12) {
                    for (let x = 0; x < 12 - this.report.last_year_reports.length; x++) {
                        workTimes.push(0);
                        neededTimes.push(0);
                        differences.push(0);
                    }
                }

                for (let x = 0; x < this.report.last_year_reports.length; x++) {
                    workTimes.push(this.report.last_year_reports[x].time_worked);
                    neededTimes.push(this.report.last_year_reports[x].time_needed);
                    differences.push(this.report.last_year_reports[x].monthly_difference);
                }
            }

            let data = [];
            data.push({name: this.$t("Work"), data: workTimes});
            data.push({name: this.$t("HoursNeeded"), data: neededTimes});
            data.push({name: this.$t("MonthlyDifference"), data: differences});

            return data;

        },
        yearlyChartCategories: function () {

            let categories = [];

            if (this.report && this.report.last_year_reports) {

                if (this.report.last_year_reports.length < 12) {
                    for (let x = 0; x < 12 - this.report.last_year_reports.length; x++) {
                        categories.push("");
                    }
                }

                for (let x = 0; x < this.report.last_year_reports.length; x++) {

                    switch (this.report.last_year_reports[x].month) {
                        case 1:
                            categories.push(this.$t("January"));
                            break;
                        case 2:
                            categories.push(this.$t("February"));
                            break;
                        case 3:
                            categories.push(this.$t("March"));
                            break;
                        case 4:
                            categories.push(this.$t("April"));
                            break;
                        case 5:
                            categories.push(this.$t("May"));
                            break;
                        case 6:
                            categories.push(this.$t("June"));
                            break;
                        case 7:
                            categories.push(this.$t("July"));
                            break;
                        case 8:
                            categories.push(this.$t("August"));
                            break;
                        case 9:
                            categories.push(this.$t("September"));
                            break;
                        case 10:
                            categories.push(this.$t("October"));
                            break;
                        case 11:
                            categories.push(this.$t("November"));
                            break;
                        case 12:
                            categories.push(this.$t("December"));
                            break;
                    }
                }
            }

            return categories;

        },
        reportDays: function () {

            let categories = [];

            if (this.report && this.report.days) {
                for (let key in this.report.days) {
                    if (this.report.days.hasOwnProperty(key)) {
                        categories.push(this.moment(key).format("D"))
                    }
                }
            }

            return categories

        }
    },
    beforeCreate() {
    },
    created() {
        this.updateUser();
    },
    mounted() {
        this.mounted = true;
        const thisIns = this;
        this.$http.get('/api/v1/profile/report')
            .then(function (response) {
                thisIns.report = response.data;
                thisIns.updateChartCategories();
                thisIns.updateYearlyChart();

            })
            .catch(function (error) {
                thisIns.$vs.notify({
                    title: 'Error',
                    text: error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                })
            });

    }
}
</script>
<style lang="scss">
.page-user-view {
    table {
        td {
            vertical-align: top;
            min-width: 170px;
            padding-bottom: .8rem;
            word-break: break-all;
        }

        &:not(.permissions-table) {
            td {
                @media screen and (max-width: 370px) {
                    display: block;
                }
            }
        }
    }
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
only screen and (min-width: 636px) and (max-width: 991px) {
    #account-info-col-1 {
        width: calc(100% - 12rem) !important;
    }

}
</style>
